module.exports = __webpack_public_path__ + "static/media/t1.ff6a6f65.jpg";